<h4 class="typography--title u-m-t-16">Search by&hellip;</h4>
<form name="schoolSearchForm" aria-label="Search for school" novalidate [formGroup]="searchForm" (ngSubmit)="onSubmit()">
    <div class="advanced-search__field">
        <label for="schoolId" class="advanced-search__label">School ID</label>
        <div class="advanced-search__input">
            <input type="text" id="schoolId" name="schoolId" formControlName="id">
            <div class="error" [hidden]="this.searchForm.get('id').valid">
                <div class="error__message">Must be a number.</div>
            </div>
        </div>
    </div>
    <div class="advanced-search__field">
        <label for="schoolName" class="advanced-search__label">School Name</label>
        <div class="advanced-search__input">
            <input type="text" id="schoolName" formControlName="longName">
        </div>
    </div>
    <div class="advanced-search__field">
        <label for="schoolId" class="advanced-search__label">District ID</label>
        <div class="advanced-search__input">
            <input type="text" id="districtId" name="districtId" formControlName="districtId">
            <div class="error" [hidden]="this.searchForm.get('districtId').valid">
                <div class="error__message">Must be a number.</div>
            </div>
        </div>
    </div>
    <div class="advanced-search__field">
        <label for="districtName" class="advanced-search__label">District Name</label>
        <div class="advanced-search__input">
            <input type="text" id="districtName" formControlName="districtName">
        </div>
    </div>
    <div class="advanced-search__field">
        <label for="county" class="advanced-search__label">County</label>
        <div class="advanced-search__input">
            <input type="text" id="county" formControlName="county">
        </div>
    </div>
    <div class="advanced-search__field">
        <label for="state" class="advanced-search__label">State</label>
        <div class="advanced-search__input">
            <select id="state" formControlName="state">
                <option value="Any">Any</option>
                <option *ngFor="let state of states" value="{{state}}">{{state}}</option>
            </select>
        </div>
    </div>
    <div class="advanced-search__field" role="group" aria-labelledby="zipCodeRadiusLabel">
        <div id="zipCodeRadiusLabel" class="advanced-search__label">Zip Code &amp; Radius</div>
        <div class="advanced-search__input">
            <div class="row row--nest row--tight">
                <div class="columns columns--tight">
                    <input type="text" aria-label="Zip code" title="Zip code" formControlName="zip">
                </div>
                <div class="columns columns--tight shrink">
                    <select aria-label="Radius" title="Radius" formControlName="radius">
                        <option value="1">1 mile</option>
                        <option value="5">5 miles</option>
                        <option value="10">10 miles</option>
                        <option value="15">15 miles</option>
                        <option value="20">20 miles</option>
                        <option value="30">30 miles</option>
                        <option value="50">50 miles</option>
                    </select>
                </div>
            </div>
            <div class="error" [hidden]="this.searchForm.get('zip').valid">
                <div class="error__message">Must be a valid zip code (xxxxx or xxxxx-xxxx)</div>
            </div>
        </div>
    </div>
    <div class="advanced-search__field">
        <label for="relationshipManager" class="advanced-search__label">Relationship Manager Location ID</label>
        <div class="advanced-search__input">
            <input type="text" id="relationshipManager" formControlName="code">
            <div class="error" [hidden]="this.searchForm.get('code').valid">
                <div class="error__message">Must be a number.</div>
            </div>
        </div>
    </div>
    <div class="advanced-search__field">
        <label for="gradeLevel" class="advanced-search__label">Grade Level</label>
        <div class="advanced-search__input">
            <select id="gradeLevel" formControlName="gradeLevel">
                <option value="Any">Any</option>
                <option value="1">Elementary</option>
                <option value="2">Middle</option>
                <option value="3">High</option>
                <option value="4">College</option>
                <option value="5">Other</option>
            </select>
        </div>
    </div>
    <div class="advanced-search__field">
        <label for="active" class="advanced-search__label">Active</label>
        <div class="advanced-search__input">
            <select id="active" formControlName="isActive">
                <option value="true">Yes</option>
                <option value="false">No</option>
                <option value="Any">Any</option>
            </select>
        </div>
    </div>
    <div class="row align-right">
        <div class="advanced-search__submit">
            <button class="btn btn--elevated" type="submit">Search</button>
        </div>
    </div>
</form>
<div class="full-page-spinner" [class.full-page-spinner--is-active]="this.hasSubmitted">
    <div class="full-page-spinner__icon"></div>
</div>
